jQuery(function ($) {
var header = document.querySelector(".header-wrapper");
var header_top= header.offsetHeight;

window.addEventListener('scroll', function(){
  if(window.scrollY >= 80){
    header.classList.add('active');
  }else{
    header.classList.remove('active');
  }
});


$(".header li .mega-menu").hover(function() {
  //$(this).find('.mega-menu__content').addClass('show');
  $(this).find('.mega-menu__content').fadeIn();
}, function() {
 // $(this).find('.mega-menu__content').removeClass('show');
  $(this).find('.mega-menu__content').fadeOut();
});

/*
$('.list-menu--inline > li').hover(function(){
  //$(this).siblings('.mega-menu__content').('on');
  $(this).trigger('click');
});
*/
       });